import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import BorrowingEmptyContentPanel from '../../shared/BorrowingEmptyContentPanel';
import { HoldsIcon } from '@bibliocommons/base-icons';

import './HoldsEmptyContentPanel.scss';

export default function HoldsEmptyContentPanel({ fetching }) {
  return (
    <BorrowingEmptyContentPanel
      className="cp-holds-empty-content-panel"
      icon={<HoldsIcon />}
      showExploreNewTitlesLink
      fetching={fetching}
      title={<FormattedMessage id="holds_empty_title" />} />
  );
}

HoldsEmptyContentPanel.propTypes = {
  fetching: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsEmptyContentPanel/HoldsEmptyContentPanel.jsx